import { ISystemEvent } from "@dl/declarations";
import * as yup from "yup";

export type FormData = Pick<
  ISystemEvent,
  | "name"
  | "description"
  | "type"
  | "url"
  | "start_date"
  | "end_date"
  | "time"
  | "region"
  | "country"
  | "city"
  | "street"
> & {
  _id?: string;
  image: string;
  subtype: string;
  collections: string[];
};

export const initialValues: FormData = {
  name: "",
  description: "",
  type: "",
  url: "",
  start_date: "",
  end_date: "",
  time: "",
  region: "",
  country: "",
  city: "",
  street: "",
  image: "",
  subtype: "",
  collections: [],
};

export const schema = yup.object().shape({
  name: yup.string().required().label("Name"),
  description: yup.string().required().label("Description"),
  type: yup.string().required().label("Type"),
  url: yup.string().url().label("URL"),
  start_date: yup.string().required().label("Start Date"),
  end_date: yup.string().required().label("End Date"),
  time: yup.string().required().label("Time"),
  region: yup.string().required().label("Region"),
  country: yup.string().required().label("Country"),
  city: yup.string().required().label("City"),
  street: yup.string().required().label("Street"),
  image: yup.string().required().label("Image"),

  subtype: yup.string().required().label("Subtype"),

  collections: yup.array().of(yup.string()).optional().label("Collections"),
});
